import {
  CcfBox,
  CcfButton,
  CcfCloseIcon,
  CcfSupervisorFilterIcon,
  CcfTextField,
  CcfTypography,
  CcfUpArrowIcon,
  useTranslator,
} from '@nice-ccf/ui-controls';
import stylesObj from './ccf-interaction-search-cases-tab.module.scss';
import {
  Button,
  FormControl,
  ListSubheader,
  Menu,
  MenuItem,
  MenuList,
  Popover,
  Select,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import 'react-datepicker/dist/react-datepicker.css';
import { Theme } from '@mui/material';

import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { useDispatch, useSelector } from 'react-redux';
import { getApplicationLocale } from '../../../../global.app.slice';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { interactionSearchData } from './ccf-interactionSearch-staticData';
import CcfInteractionSearchStyle from '../../ccf-interaction-search-styles';
import {
  ccfInteractionSearchActions,
  getFiltersMenuElement,
} from '../../ccf-interaction-search.slice';

/* eslint-disable-next-line */
export interface CcfInteractionSearchCasesFiltersProps {
  rowData: any;
  setRowData: any;
  setUpdatedRowData: any;
  updatedRowData: any;
}

export interface PopOverMenuItems {
  items: Array<PopOverMenuItem>;
}

export interface PopOverMenuItem {
  label?: string;
  icon?: React.ReactElement | string;
  options: any;
  selectedOption: string;
  type: string;
  startDate: string;
  endDate: string;
}
/**
 * CcfInteractionSearch - used to display Notes in contact card
 * @param props -? - CcfInteractionSearchProps
 * @example - <CcfInteractionSearch />
 */
export function CcfInteractionSearchCasesFilters({
  rowData,
  setRowData,
  setUpdatedRowData,
  updatedRowData,
}: CcfInteractionSearchCasesFiltersProps) {
  const filtersDropdownOptions = {
    popOverHeader: 'Filter Options',
    menuItems: [
      {
        items: [
          {
            id: 0,
            label: 'CHANNEL',
            options: [],
            selectedOption: '',
            type: 'select',
          },
          {
            id: 1,
            label: 'STATUS',
            options: [],
            selectedOption: '',
            type: 'select',
          },
          {
            id: 2,
            label: 'SKILL',
            options: ['Usha-Routing-Queue'],
            selectedOption: '',
            type: 'select',
          },
          {
            id: 3,
            label: 'INBOX ASSIGNEE',
            options: [],
            selectedOption: '',
            type: 'select',
          },
          // {
          //   id: 4,
          //   label: 'TAG',
          //   options: [],
          //   selectedOption: '',
          //   type: 'select',
          // },
          {
            id: 4,
            label: 'CREATED DATE RANGE',
            startDate: '',
            endDate: '',
            type: 'date',
          },
        ],
      },
    ],
  };
  const locale = useSelector(getApplicationLocale);

  const theme = useTheme();
  const anchorEl = useSelector(getFiltersMenuElement);
  const open = Boolean(anchorEl);
  const styles = CcfInteractionSearchStyle(theme);
  const [filterSelectionOptions, setFilterSelectionOptions] = useState(Array);

  const [translate] = useTranslator();

  const [dropdownOptions, setDropdownOptions]: any = useState(
    filtersDropdownOptions
  );
  const theme1: Theme = useTheme();
  const isSmView = useMediaQuery(theme1.breakpoints.down('xl'), {
    noSsr: true,
  });

  const [updatedDropdownOptions, setUpdatedDropdownOptions] = useState(Array);
  // const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const dispatch = useDispatch();
  useEffect(() => {
    const updatedOptions: any = {
      'INBOX ASSIGNEE': [],
      STATUS: [],
      CHANNEL: [],
      SKILL: [],
    };
    interactionSearchData.data.forEach((op) => {
      updatedOptions.CHANNEL.push(
        op.channelId ? `${op.channelId.split('_')[0]}` : ''
      );

      updatedOptions.STATUS.push(op.status ? `${op.status}` : '');

      updatedOptions['INBOX ASSIGNEE'].push(
        op.inboxAssigneeUser ? `${op.inboxAssigneeUser}` : ''
      );

      updatedOptions.SKILL.push(`${op.skill}`);
    });

    const updatedItem = JSON.parse(
      JSON.stringify(dropdownOptions.menuItems[0]?.items)
    );

    const setOptions = updatedItem.map((res: any, i: any) => ({
      ...res,
      options: [...new Set(updatedOptions[res.label])],
    }));
    setDropdownOptions((prev: any) => {
      return { ...prev, menuItems: [{ items: setOptions }] };
    });
  }, []);

  /**
   * Function to open pop over menu
   * @param event - any
   * @example openPopOverMenu(event)
   */
  const handleChangeFilter = (event: any, i: any, type: any) => {
    setUpdatedDropdownOptions(filterSelectionOptions);
    const updatedItem = JSON.parse(
      JSON.stringify(dropdownOptions.menuItems[0]?.items)
    );

    let d = Array;
    if (type === 'select') {
      d = updatedItem.map((x: any) =>
        x.id === i ? { ...x, selectedOption: event.target.value } : x
      );
    } else if (type === 'startDate') {
      d = updatedItem.map((x: any) =>
        x.id === i ? { ...x, startDate: new Date(event) } : x
      );
    } else {
      d = updatedItem.map((x: any) =>
        x.id === i ? { ...x, endDate: new Date(event) } : x
      );
    }

    setFilterSelectionOptions(d);

    setDropdownOptions((prev: any) => {
      return { ...prev, menuItems: [{ items: d }] };
    });
  };

  /**
   * clearFilterData used to clear filter data
   * @example <clearFilterData />
   */
  const clearFilterData = () => {
    setRowData(JSON.parse(JSON.stringify(updatedRowData)));
    const clearData = dropdownOptions.menuItems[0].items.map((x: any) =>
      Object.keys(x).includes('startDate') || Object.keys(x).includes('endDate')
        ? { ...x, startDate: '', endDate: '' }
        : { ...x, selectedOption: '' }
    );
    setDropdownOptions((prev: any) => {
      return { ...prev, menuItems: [{ items: clearData }] };
    });
  };

  /**
   * handleApplyClick used to  filter data
   * @example <handleApplyClick />
   */
  function arraysEqual(arr1: any, arr2: any) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    return arr1.every((obj1: any, index: any) => {
      const obj2 = arr2[index];
      return JSON.stringify(obj1) === JSON.stringify(obj2);
    });
  }

  /**
   * handleApplyClick used to  filter data
   * @example <handleApplyClick />
   */
  const handleApplyClick = () => {
    const rd = JSON.parse(JSON.stringify(rowData));
    const opt = JSON.parse(JSON.stringify(filterSelectionOptions));
    const selectedOptions = opt
      .filter(
        (item: any) =>
          (item.selectedOption &&
            (item.selectedOption !== '' ||
              item.selectedOption !== 'undefined')) ||
          item.startDate ||
          item.endDate
      )
      .map((x: any) =>
        x.label !== 'CREATED DATE RANGE'
          ? `${x.label}@${x.selectedOption}`
          : `${x.label}@${x.startDate}#${x.endDate}`
      );

    const searchData = [];
    const finalD = arraysEqual(updatedDropdownOptions, filterSelectionOptions)
      ? rd
      : updatedRowData;
    for (const obj of finalD) {
      const values = Object.values(obj);
      if (
        selectedOptions.every(
          (element: any) =>
            element.split('@')[0] !== 'CREATED DATE RANGE' &&
            values.includes(`${element.split('@')[1]}`)
        )
      ) {
        searchData.push(obj);
        selectedOptions.forEach((element: any) => {
          const index = values.indexOf(`${element.split('@')[1]}`);
          if (index !== -1) {
            values.splice(index, 1);
          }
        });
      } else if (
        selectedOptions.every(
          (element: any) => element.split('@')[0] === 'CREATED DATE RANGE'
        )
      ) {
        let dateData = { startDate: '', endDate: '' };
        selectedOptions.forEach(
          (element: any) =>
            (dateData = {
              ...dateData,
              startDate: element.split('@')[1].split('#')[0],
              endDate: element.split('@')[1].split('#')[1],
            })
        );

        const d = new Date(obj.createdAt);
        const startDate = new Date(dateData.startDate);
        const endDate = new Date(dateData.endDate);
        const isBetweenCustom = d >= startDate && d <= endDate;

        if (isBetweenCustom) {
          searchData.push(obj);
          selectedOptions.forEach((element: any) => {
            const index = values.indexOf(obj.createdAt);
            if (index !== -1) {
              values.splice(index, 1);
            }
          });
        }
      }
    }

    setFilterSelectionOptions(selectedOptions);

    setRowData(searchData);
    // setAnchorEl(null);
  };
  return (
    <CcfBox
      id={`interactionSearch_cases_tab_filtersContainer`}
      className={stylesObj.filterIconBlock}
      sx={isSmView ? { width: '30%' } : { width: '8%' }}
    >
      <Button
        data-testid="ccf-popover-button"
        aria-controls="callControlDialog"
        aria-haspopup="true"
        onClick={(e: React.MouseEvent<HTMLElement>) =>
          dispatch(
            ccfInteractionSearchActions.updateFiltersMenuElement(
              e.currentTarget
            )
          )
        }
        className="popOverOverflow"
        disableRipple
        sx={{
          gap: '7px',
          padding: 0,
          width: '24px',
          height: '38px',
          minWidth: 'auto',
          '&.MuiButtonBase-root:hover': { bgcolor: 'transparent' },
        }}
        id="agent_interactionSearch_filters_popOver_button"
      >
        <CcfSupervisorFilterIcon style={{ fontSize: 14 }} />
        <CcfTypography
          className={stylesObj.filtersHeader}
          translationKey={'filters'}
        ></CcfTypography>
      </Button>
      <Menu
        id="customizable-columns"
        MenuListProps={{
          'aria-labelledby': 'customize-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={() =>
          dispatch(ccfInteractionSearchActions.updateFiltersMenuElement(null))
        }
        sx={{
          '& .MuiMenu-paper': {
            border: `1px solid ${theme?.palette?.text?.grey}`,
            width: isSmView ? '235px' : '336px',
            left:isSmView ? '115px !important' : '191px',
            '&::-webkit-scrollbar': {
              width: '0.3rem',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: theme?.palette?.background?.scrollThumb,
              borderRadius: '2rem',
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: theme?.palette?.background?.scrollTrack,
            },
            '&::-webkit-scrollbar-thumb:hover': {
              backgroundColor: theme?.palette?.background?.scrollThumbHover,
            },
            '& .MuiMenu-list': {
              paddingTop: 0,
              paddingBottom: 0,
            },
          },
        }}
      >
        <ListSubheader
          component="div"
          id="list-subheader"
          sx={styles.listSubheader}
        >
          <CcfTypography sx={styles.customizeText}>Filter Options</CcfTypography>
          <CcfCloseIcon
            viewBox="-8 -4 32 32"
            sx={styles.closeIcon}
            data-testid="close-button"
            onClick={() =>
              dispatch(
                ccfInteractionSearchActions.updateFiltersMenuElement(null)
              )
            }
          />
        </ListSubheader>
        <div
          id="filtersPopOver"
          style={{ width: isSmView ? '235px' : '336px' }}
          className={stylesObj['ccfPopOver']}
        >
          {dropdownOptions.menuItems.map(
            (parentItem: PopOverMenuItems, index: number) => (
              <MenuList key={index} style={{ paddingTop: '0px' }}>
                {parentItem.items?.map(
                  (childItem: PopOverMenuItem, index: number) => (
                    <MenuItem
                      id={`agent_activeContact_inboxPopOver_${childItem.label}`}
                      key={index}
                      className="flexDisplay"
                      data-testId={`popover-menu-item-${index}`}
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        flexDirection: 'column',
                        paddingBottom: '0px',
                      }}
                    >
                      <CcfBox>
                        <CcfTypography className={stylesObj.menuHeaderName}>
                          {childItem.label}{' '}
                        </CcfTypography>
                      </CcfBox>

                      {childItem.type === 'select' && (
                        <FormControl
                          variant="outlined"
                          // className={classes.formControl}
                          size="medium"
                          style={{
                            width: '100%',
                            marginBottom: '0px',
                          }}
                          id={`${id}` || 'demo-simple-select'}
                        >
                          <Select
                            labelId="demo-simple-select-label"
                            variant="outlined"
                            sx={{
                              '&& fieldset': {
                                border: '1px solid #c4c4c4',
                              },
                            }}
                            className={stylesObj.filtersDropdown}
                            IconComponent={() => (
                              <CcfUpArrowIcon
                              // className={classes.arrowIconForDropdown}
                              />
                            )}
                            placeholder="Select"
                            value={
                              // selectedOption.filter((y: any) => {
                              //   return y[`${childItem?.label}`]?.value;
                              // })[0]
                              childItem.selectedOption || ''
                            }
                            onChange={(event: any) => {
                              handleChangeFilter(event, index, 'select');
                            }}
                            // className={classes.input}
                            label={childItem.label}
                          >
                            {childItem.options.map(
                              (option: string, index: number) => {
                                return (
                                  <MenuItem
                                    value={option}
                                    key={index}
                                    id={`interactionSearch_filtersOptions_${option}`}
                                  >
                                    {option}
                                  </MenuItem>
                                );
                              }
                            )}
                          </Select>
                        </FormControl>
                      )}

                      {childItem.type === 'date' && (
                        <div
                          id={`time`}
                          style={{
                            display: 'flex',
                            gap: '5px',
                          }}
                        >
                          <CcfBox
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                            }}
                          >
                            <Typography style={{ fontSize: '12px' }}>
                              Start Date
                            </Typography>
                            <LocalizationProvider
                              dateAdapter={AdapterDayjs}
                              adapterLocale={locale}
                            >
                              <DateTimePicker
                                value={
                                  childItem.startDate
                                    ? dayjs(childItem.startDate)
                                    : null
                                }
                                onChange={(value: any) => {
                                  handleChangeFilter(
                                    value.toISOString(),
                                    index,
                                    'startDate'
                                  );
                                }}
                                key={locale}
                                renderInput={(params: any) => (
                                  <CcfTextField
                                    {...params}
                                    id="date-time"
                                    size="small"
                                    variant="outlined"
                                  />
                                )}
                                PopperProps={{
                                  placement: 'auto',
                                }}
                                // components={{
                                //   OpenPickerIcon: DatePickerIcon,
                                // }}
                                // minDateTime={dayjs()}
                              />
                            </LocalizationProvider>
                          </CcfBox>
                          <CcfBox
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                            }}
                          >
                            <Typography style={{ fontSize: '12px' }}>
                              End Date
                            </Typography>
                            <LocalizationProvider
                              dateAdapter={AdapterDayjs}
                              adapterLocale={locale}
                            >
                              <DateTimePicker
                                value={
                                  childItem.endDate
                                    ? dayjs(childItem.endDate)
                                    : null
                                }
                                onChange={(value: any) => {
                                  handleChangeFilter(
                                    value.toISOString(),
                                    index,
                                    'endDate'
                                  );
                                }}
                                key={locale}
                                renderInput={(params: any) => (
                                  <CcfTextField
                                    {...params}
                                    id="date-time"
                                    size="small"
                                    variant="outlined"
                                  />
                                )}
                                PopperProps={{
                                  placement: 'auto',
                                }}
                                // minDateTime={dayjs()}
                              />
                            </LocalizationProvider>
                          </CcfBox>
                        </div>
                      )}
                    </MenuItem>
                  )
                )}
              </MenuList>
            )
          )}
          <CcfBox className={stylesObj.btnBox}>
            <CcfButton
              className={stylesObj.btn}
              id={`agent_interactionSearch_filters_clear_button`}
              onClick={() => {
                clearFilterData();
              }}
            >
              <CcfTypography
                className={stylesObj.btnText}
                sx={{ color: '#545cbc' }}
                // className={`${classes.btnText} ${classes.txtCancel}`}
              >
                Clear
              </CcfTypography>
            </CcfButton>
            <CcfButton
              className={stylesObj.btn}
              primary
              // className={`${classes.btn} ${classes.saveButton}`}
              // disabled={!chatMessage}
              id={`agent_interactionSearch_filters_apply_button`}
              onClick={() => {
                handleApplyClick();
                dispatch(
                  ccfInteractionSearchActions.updateFiltersMenuElement(null)
                );
              }}
            >
              <CcfTypography
                className={stylesObj.btnText}
                // className={`${classes.btnText} ${
                //   chatMessage ? classes.txtSave : classes.txtSaveDisabled
                // }`}
              >
                Apply
              </CcfTypography>
            </CcfButton>
          </CcfBox>
        </div>
      </Menu>
    </CcfBox>
  );
}

export default CcfInteractionSearchCasesFilters;
